import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: center;
  white-space: nowrap;
  color: ${({ theme }) => theme.colors.gray['090']};
`;
